import React from 'react';
import { FiChevronDown, FiChevronLeft, FiChevronRight, FiEdit, FiMail, FiMapPin, FiPhone, FiUser } from 'react-icons/fi'

const Settings = () => {
    return (
      <React.Fragment>
         <div>
                <div className="flex justify-between m-3 cursor-pointer">
                  <div
                    className="bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-white rounded-md p-2 flex items-center justify-center"
                  >
                    <FiChevronLeft />
                  </div>
                </div>
  
                <div
                  className="flex flex-col items-center justify-center gap-2 mb-12"
                >
                  <div
                    className="w-24 h-24 rounded-full bg-gray-300 dark:bg-gray-700 relative border border-2 border-gray-500 cursor-pointer"
                  >
                    <div
                      className="absolute right-0 border border-2 border-gray-300 bottom-0 w-10 h-10 bg-gray-400 dark:bg-gray-500 rounded-full flex items-center justify-center"
                    >
                      <FiEdit className="h-4 text-gray-100" />
                    </div>
                  </div>
                  <div className="flex flex-col items-center justify-center">
                    <div
                      className="text-2xl font-medium mb-2 dark:text-white text-gray-600"
                    >
                      John Doe
                    </div>
                    <div
                      className="flex items-center justify-center bg-green-500/10 text-green-600 rounded-full pl-4 pr-2 cursor-pointer"
                    >
                      <p>Available</p>
                      <FiChevronDown className="h-4" /> 
                    </div>
                  </div>
                </div>
  
                <ul x-data="{ id: 1 }">
                  <li>
                    <div
                      // @click="id==1 ?  (id = 0) : id=1 "
                      // :className="id==1?'dark:bg-gray-700 bg-gray-300':''"
                      className="p-3 border-t border-gray-300 dark:border-gray-500 dark:border-gray-700 flex items-center justify-between cursor-pointer"
                    >
                      <div>
                        <div className="font-medium text-gray-600 dark:text-gray-300">
                          Information
                        </div>
                      </div>
                      <div>
                        <FiChevronRight
                          x-show="id!=1"
                          className="h-5 text-gray-500 dark:text-gray-200"
                        />
                          <FiChevronDown
                          x-show="id==1"
                          className="h-5 text-gray-500 dark:text-gray-200"
                        /> 
                      </div>
                    </div>
  
                    <ul x-show="id==1" className="mb-3">
                      <li>
                        <div className="flex justify-between items-center p-2 px-3">
                          <div className="flex items-center gap-3">
                            <div className="">
                              <div
                                className="font-medium text-sm text-gray-400 dark:text-gray-300"
                              >
                                Name
                              </div>
                              <div className="dark:text-white text-gray-700">
                                John Doe
                              </div>
                            </div>
                          </div>
                          <div>
                            <FiUser
                              className="text-gray-400 dark:text-gray-300 h-5"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="flex justify-between items-center p-2 px-3">
                          <div className="flex items-center gap-3">
                            <div className="">
                              <div
                                className="font-medium text-sm text-gray-400 dark:text-gray-300"
                              >
                                Email
                              </div>
                              <div className="dark:text-white text-gray-700">
                                example@example.com
                              </div>
                            </div>
                          </div>
                          <div>
                            <FiMail                            
                              className="text-gray-400 dark:text-gray-300 h-5"
                            /> 
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="flex justify-between items-center p-2 px-3">
                          <div className="flex items-center gap-3">
                            <div className="">
                              <div
                                className="font-medium text-sm text-gray-400 dark:text-gray-300"
                              >
                                Phone
                              </div>
                              <div className="dark:text-white text-gray-700">
                                +1 (452) 23456789
                              </div>
                            </div>
                          </div>
                          <div>
                            <FiPhone
                              className="text-gray-400 dark:text-gray-300 h-5"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="flex justify-between items-center p-2 px-3">
                          <div className="flex items-center gap-3">
                            <div className="">
                              <div
                                className="font-medium text-sm text-gray-400 dark:text-gray-300"
                              >
                                Address
                              </div>
                              <div className="dark:text-white text-gray-700">
                                Chicago, USA
                              </div>
                            </div>
                          </div>
                          <div>
                            <FiMapPin
                              className="text-gray-400 dark:text-gray-300 h-5"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
  
                  <li>
                    <div
                     // @click="id==4 ?  (id = 0) : id=4 "
                     // :className="id==4?'dark:bg-gray-700 bg-gray-300':''"
                      className="p-3 border-b border-t border-gray-300 dark:border-gray-500 dark:border-gray-700 flex items-center justify-between cursor-pointer"
                    >
                      <div>
                        <div className="font-medium text-gray-600 dark:text-gray-300">
                          Help
                        </div>
                      </div>
                      <div>
                        <FiChevronRight
                          x-show="id!=4"
                          className="h-5 text-gray-500 dark:text-gray-200"
                        /> <FiChevronDown
                          x-show="id==4"
                          className="h-5 text-gray-500 dark:text-gray-200"
                        /> 
                      </div>
                    </div>
                    <div x-show="id==4"></div>
                  </li>
                  <li>
                    <div
                      // @click="id==5 ?  (id = 0) : id=5 "
                      // :className="id==5?'dark:bg-gray-700 bg-gray-300':''"
                      className="p-3 border-b border-gray-300 dark:border-gray-500 dark:border-gray-700 flex items-center justify-between cursor-pointer"
                    >
                      <div>
                        <div className="font-medium text-gray-600 dark:text-gray-300">
                          FAQ
                        </div>
                      </div>
                      <div>
                        <FiChevronRight x-show="id!=5"
                          className="h-5 text-gray-500 dark:text-gray-200"
                        /> 
                        <FiChevronDown x-show="id==5"
                          className="h-5 text-gray-500 dark:text-gray-200" />
                      </div>
                    </div>
                    <div x-show="id==5"></div>
                  </li>
                </ul>
          </div>
      </React.Fragment>
    )
  }
  
export default Settings;
